var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 43,
  height: 28,
  viewBox: "0 0 43 28"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-603 -653)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 43,
  height: 28,
  rx: 2,
  transform: "translate(603 653)",
  fill: "#34485e"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(611 604.281)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.9,63.173a8.452,8.452,0,1,1-8.452-8.454A8.452,8.452,0,0,1,16.9,63.173Z",
  fill: "#e2574c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M117.885,54.719a8.4,8.4,0,0,0-5.05,1.686h.007a7.244,7.244,0,0,1,.819.765L111.9,57.2a8.693,8.693,0,0,0-.763.9h3.1a7.855,7.855,0,0,1,.652.842h-4.315a8.423,8.423,0,0,0-.432.843h5.238a7.2,7.2,0,0,1,.364.816h-5.912a8.142,8.142,0,0,0-.235.894h6.395c.063.293.111.563.144.839h-6.665c-.028.278-.042.561-.042.845h6.756a7.425,7.425,0,0,1-.052.845h-6.662q.043.43.127.845h6.384c-.066.274-.142.549-.238.835h-5.931a8.206,8.206,0,0,0,.318.844h5.25a7.7,7.7,0,0,1-.492.842h-4.329a8.224,8.224,0,0,0,.564.849l3.114.046a8.229,8.229,0,0,1-.916.79c.017.014-.5,0-1.507-.018a8.452,8.452,0,1,0,6.068-14.333Z",
  transform: "translate(-99.283)",
  fill: "#f4b459"
})))));
export default __webpack_public_path__ + "static/media/credit-debit.653741c0.svg";
export { SvgComponent as ReactComponent };